import { useAuth } from "src/hooks/useAuth";

import Content from "src/components/ui/Content";
import Panel from "src/components/ui/Panel";

import CustomerInfo from "src/modules/order/shipping-order/status-order/CustomerInfo";
import PurchaseInfo from "src/modules/order/shipping-order/status-order/PurchaseInfo";
import DocumentInfo from "src/modules/order/shipping-order/status-order/Document";
import Note from "src/modules/order/shipping-order/status-order/Note";

const Pending = ({ info, callbackCloseDocument, setIsLoading }) => {
  const { user } = useAuth();
  const isAdmin = user?.role_id === 1;

  return (
    <>
      <Content>
        <Panel>
          <CustomerInfo info={info} />
        </Panel>

        <Panel>
          <PurchaseInfo info={info?.order} />
        </Panel>

        {isAdmin && (
          <Panel>
            <DocumentInfo
              info={info}
              isCloseDialog={callbackCloseDocument}
              setIsLoading={setIsLoading}
            />
          </Panel>
        )}

        <Panel>
          <Note info={info?.order} />
        </Panel>
      </Content>
    </>
  );
};

export default Pending;
